import axios from 'axios';
import Cookies from 'js-cookie';
import tokenManager from './tokenManager';
import API_BASE_URL from './apiConfig';

// Create axios instance with base configuration
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // Enable sending cookies with requests
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for additional configuration if needed
axiosInstance.interceptors.request.use(
  (config) => {
    // Try to get token from tokenManager first (in-memory, more secure)
    let token = tokenManager.getAuthToken();
    
    // Fallback to cookies for backward compatibility
    if (!token) {
      token = Cookies.get('token');
    }
    
    // Only add Authorization header if token exists and is not empty
    if (token && token.trim() !== '' && token !== 'undefined' && token !== 'null') {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    // If uploading FormData, let axios set the correct multipart boundary.
    if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
      if (config.headers && config.headers['Content-Type']) {
        delete config.headers['Content-Type'];
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle common errors with detailed information
    if (error.response) {
      const errorDetails = {
        status: error.response.status,
        url: error.config?.url || 'unknown',
        method: error.config?.method?.toUpperCase() || 'unknown',
        origin: error.response.headers?.['x-error-origin'] || 'unknown',
        data: error.response.data
      };

      console.error(`API Error ${error.response.status}`);
    } else {
      console.error('Error setting up request:', error.message);
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
